const getForwardStageName = stageName => `Stage was moved forward (${stageName})`;

export default getForwardStageName;
